/**
 * Ted 10-09 (#915) — "Client not notified".
 *
 * A reservation the desk entered without telling the client looked exactly
 * like one the client was told about, so whoever answered the phone next was
 * guessing. This pill says so on the row — the Bookings list, the deep-linked
 * row the desk opens from a search (`?focus=`), and the Front Desk card.
 *
 * It renders ONLY on `notified === false`. The server sends `null` when the
 * question does not apply (the client booked it themselves, the Gingr mirror,
 * an added-service leg) or when it could not tell; an older server omits the
 * field (`undefined`). Neither may render as "not notified" — "we don't know"
 * and "no" must never look alike (Principle 5). A cancelled reservation shows
 * nothing either: there is nothing left to tell anyone about.
 *
 * Words, not colour, carry the meaning (status is never colour-only); the
 * title is a hover nicety, not where the meaning lives.
 */
export interface ClientNotNotifiedPillProps {
  notified: boolean | null | undefined;
  status?: string | null;
  testId?: string;
}

export function ClientNotNotifiedPill({
  notified,
  status,
  testId,
}: ClientNotNotifiedPillProps): JSX.Element | null {
  if (notified !== false) return null;
  if (status === 'cancelled') return null;
  return (
    <span
      className="ferro-client-unnotified"
      data-testid={testId}
      title="No confirmation email was sent to the client for this reservation"
    >
      Client not notified
    </span>
  );
}
